var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0768 4.96094L6.52344 10.477V21.5055L16.0768 27.0179L25.6227 21.5055V10.477L16.0768 4.96094ZM22.7944 19.8714L16.0768 23.7497L9.35543 19.8714V12.1075L16.0768 8.22918L22.7944 12.1075V19.8714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5325 18.5668L16.0737 21.14L11.6113 18.5668V13.4167L16.0737 10.8398L20.5325 13.4167L18.6765 14.4889L16.0737 12.9842L13.471 14.4889V17.4909L16.0737 18.9957L18.6765 17.4909L20.5325 18.5668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcro);
export default __webpack_public_path__ + "static/media/tcro.d47ba110f3322549a4e79e3261208ee2.svg";
export { ForwardRef as ReactComponent };